import { render, staticRenderFns } from "./CreateTech.vue?vue&type=template&id=ab1787fe&scoped=true"
import script from "./CreateTech.vue?vue&type=script&lang=js"
export * from "./CreateTech.vue?vue&type=script&lang=js"
import style0 from "./CreateTech.vue?vue&type=style&index=0&id=ab1787fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1787fe",
  null
  
)

export default component.exports